



































































import Component from "vue-class-component";
import { getModule } from "vuex-module-decorators";
import { Watch } from "vue-property-decorator";

import BaseComponent from "@/components/base-component.vue";
import SearchResults from "@/components/search-results/search-results.vue";
import SearchParticipantsEmail from "@/components/search-participants-email/search-participants-email.vue";
import Loader from "@/components/loader.vue";
import { SearchState } from "@/store/modules/search";
import { EventsState } from "@/store/modules/events";
import { CartState } from "@/store/modules/cart";
import { SettingsState } from "@/store/modules/settings";
import { ProductTypes } from "@/product-types";
import { SearchTypes } from "@/search-types";

@Component({
  name: "Search",
  components: {
    SearchResults,
    SearchParticipantsEmail,
    Loader,
  },
})
export default class Search extends BaseComponent {

  private readonly searchState: SearchState = getModule(SearchState, this.$store);
  private readonly eventsState: EventsState = getModule(EventsState, this.$store);
  private readonly cartState: CartState = getModule(CartState, this.$store);
  private readonly settingsState: SettingsState = getModule(SettingsState, this.$store);

  productTypes: any = ProductTypes;

  event: any = null;
  eventId: string = "";
  eventName: string = "";
  eventDate: string = "";
  isAllPhotosVisible: boolean = false;
  is2FAEnabled: boolean = true;
  searchType: string = "";
  searchToken: any = null;
  recentSearch: any = null;
  runnerNum: string = "";
  runnerFrameValues: string = "";
  byFace: string = "";
  
  faceImage: string = "";
  selfieId: string = "";
  personId: string = "";
  
  photos: string = "[]";
  notFound: string = "";

  showResults: boolean = false;
  showIsProcessing: boolean = false;
  showChoiceParticipant: boolean = false;
  participants: any[] = [];

  backPageData: any = null;

  get enableCookies(): boolean {
    return this.settingsState.enableCookies === true;
  }

  get storage(): any {
    return this.enableCookies ? sessionStorage : localStorage;
  }

  get backPage(): string {
    return this.$store.state.goBack;
  }

  get newPage(): string {
    return this.$store.state.goPage;
  }

  get number(): string {
    return this.$route.params.number;
  }

  get paramId(): string {
    return this.$route.params.id;
  }

  get birthDate(): string {
    return this.$route.params.birthDate;
  }

  get code(): string {
    return this.$route.params.code;
  }

  get surname(): string {
    return this.$route.params.surname;
  }

  get gift(): object|null {
    return this.$route.params.gift ? JSON.parse(this.$route.params.gift) : null;
  }

  get photosWithFrameAdd(): boolean {
    return this.$route.params.photosWithFrameAdd === 'true';
  }

  get addPhotosWithMe(): boolean {
    return this.$route.params.addPhotosWithMe === 'true';
  }

  get hasArgs(): boolean {
    return (this.paramId !== undefined && this.number !== undefined);
  }

  get showLoader(): boolean {
    if (!this.isEmail) {
      return !this.hasArgs || !this.showResults;
    }
    return !this.showResults;
  }

  get isEmail(): boolean {
    return this.$route.name === 'search-verify-email';
  }

  get startNumberVerificationToken(): any {
    return this.$route.query.token;
  }

  get photosPerPage(): number {
    if (this.smOnly || this.mdOnly) return 12;
    return 50;
  }

  isStartNumber(id: string): boolean {
    if (!id) return false;
    if (!this.isEmail && id.indexOf("+") < 0) return true;
    return false;
  }

  @Watch("backPage")
  async goBack(page: string): Promise<void> {
    await this.setBackPageData(page);
  }

  @Watch("newPage")
  async goPage(page: string): Promise<void> {
    await this.setBackPageData(page);
  }

  async setBackPageData(page: string): Promise<void> {
    if (!page) return;

    if (this.showIsProcessing) {
      await this.$router.push("/");
      return;
    }
    
    this.backPageData = {
      name: page, 
      params: { 
        eventId: this.eventId, 
        eventName: this.eventName, 
        eventDate: this.eventDate, 
      } 
    };
  }

  async searchByTag(eventId: string, runnerNum: string): Promise<void> {
    const payloadForToken = {
      eventId,
      payload: {},
    };

    const payload: any = {
      eventId: eventId,
      token: '',
      pagination: { offset: 0, count: this.photosPerPage },
    };

    const searchData = {
      event: { ...this.event },
      search: {},
      date: Date.now(),
    };

    if (!this.isStartNumber(runnerNum)) {
      const num: string[] = runnerNum.split("+");
      if (num.length != 2) {
        await this.$router.push("/");
        return;
      }
      await this.searchState.loadBySelfieId({ selfieId: num[0] });
      if (this.searchState.searchError) {
        await this.$router.push("/");
        return;
      }
      if (num[1] === "undefined") {
        this.byFace = "true";
        await this.showNotFoundResults();
        return;
      }

      this.byFace = "true";
      const faceUrl = this.searchState.persons.length > 0 ? this.searchState.persons[0].faceUrl : "";
      searchData.search = { selfieId: num[0], personId: num[1], faceUrl: faceUrl };
      payloadForToken.payload = { personId: num[1] };
    } else {
      searchData.search = { startNumber: runnerNum.toUpperCase() };
      payloadForToken.payload = { startNumber: runnerNum.toUpperCase() };
    }

    const tokenResult: any = await this.searchState.getToken(payloadForToken);
    if (tokenResult.status !== 200) {
      await this.showNotFoundResults();
      return;
    }
    const token = this.searchState.searchToken ? this.searchState.searchToken.value : '';
    const complementable = this.searchState.searchToken ? this.searchState.searchToken.complementable === true : false;
    payload.token = token;
    searchData.search = { token, complementable, ...searchData.search };
    this.searchToken = this.searchState.searchToken ? this.searchState.searchToken : null;

    await this.searchState.searchByTag(payload);

    if (this.searchState.searchError) {
      await this.showNotFoundResults();
      return;
    }

    await this.saveRecentSearch(searchData);

    if (this.searchState.photos.length > 0) {
      await this.showFoundResults();
      // console.log('= found');
    } else {
      await this.showNotFoundResults();
      // console.log('= not found');
    }
  }

  async setEventParams(): Promise<void> {
    if (this.event === null) {
      this.$store.state.history = [];
      await this.$router.push("/");
      return;
    }

    this.eventId = this.event.eventId;
    this.eventName = this.event.title;
    this.eventDate = this.event.date.slice(0, 10);
    this.is2FAEnabled = this.event.is2FAEnabled;
    this.isAllPhotosVisible = this.event.allPhotosVisibility ? this.event.allPhotosVisibility === 'Visible' : false;
  }

  async showFoundResults(): Promise<void> {
    this.setEventParams();
    
    if (this.byFace === "true") {
      this.faceImage = this.searchState.persons.length > 0 ? this.searchState.persons[0].faceUrl : "";
      this.selfieId = this.searchState.selfieId;
      this.personId = this.searchState.persons.length > 0 ? this.searchState.persons[0].personId : "";
    } else {
      this.faceImage = "";
      this.selfieId = "";
      this.personId = "";
    }

    await this.setValuesForFrame();

    let tag: string = "";
    if (this.byFace === "true") {
      tag = `${this.selfieId}+${this.personId}`;
    } else {
      tag = `${this.number.toUpperCase()}`;
    }
    await this.settingsState.setMyPhotosLink(`/search/${this.event.externalEventId}/${tag}`);
    await this.settingsState.setVideoLink(`/search/${this.event.externalEventId}/${tag}/video`);
    
    this.photos = JSON.stringify(this.searchState.photos);
    this.notFound = "false";

    this.showResults = true;
    
    this.settingsState.trackPage("search");
  }

  async showNotFoundResults(): Promise<void> {
    this.setEventParams();
    this.runnerNum = this.byFace === "true" ? "" : this.number.toUpperCase();
    this.runnerFrameValues = "";

    if (this.byFace === "true") {
      this.faceImage = this.searchState.persons.length > 0 ? this.searchState.persons[0].faceUrl : "";
      this.selfieId = this.searchState.selfieId;
      this.personId = this.searchState.persons.length > 0 ? this.searchState.persons[0].personId : this.number;
    } else {
      this.faceImage = "";
      this.selfieId = "";
      this.personId = "";
    }

    await this.settingsState.setMyPhotosLink("");
    await this.settingsState.setVideoLink("");

    this.photos = JSON.stringify([]);
    this.notFound = "true";

    this.showResults = true;

    this.settingsState.trackPage("search");
  }

  async setValuesForFrame(): Promise<void> {
    if (this.byFace === "true") {
      this.runnerNum = '';
      return;
    } else if (this.isEmail) {
      this.runnerNum = 'email';
      return;
    } else {
      this.runnerNum = this.number.toUpperCase();
    }
    
    await this.searchState.clearFound();

    const payload: any = { eventId: this.eventId, search: this.runnerNum };
    await this.searchState.searchQuick(payload);

    const runners: any[] = this.searchState.runners.filter((i: any) => i.number === this.runnerNum);
    if (runners.length == 0 || runners.length > 1) return;

    const value = runners[0];
    const runnerFrameValues: any = {
      competitorId: value.competitorId || "",
    };
    if (value.surname) runnerFrameValues["surname"] = value.surname;
    if (value.firstName) runnerFrameValues["firstName"] = value.firstName;
    if (value.time) runnerFrameValues["time"] = value.time;
    if (value.position) runnerFrameValues["position"] = value.position.toString();
    if (value.distance) runnerFrameValues["distance"] = value.distance;
    this.runnerFrameValues = JSON.stringify(runnerFrameValues);
  }

  async saveRecentSearch(data: { event: any, search: any, date: number }): Promise<void> {
    const itemName = "eventRecentSearch";
    let value: any = this.storage.getItem(itemName)
    if (value) {
      try {
        value = JSON.parse(value);
        value = await this.addSearch(value, data);
        await this.saveRecent(itemName, value);
        return;
      } catch (e) {
        await this.saveFirstRecent(itemName, data);
      }      
    } else {
      await this.saveFirstRecent(itemName, data);
    }
  }

  async addSearch(items: any[], data: { event: any, search: any, date: number }): Promise<any[]> {
    const result: any[] = [];

    let duplicate: boolean = false;

    for (let i = 0; i < items.length; i++) {
      if (items[i].event.eventId === data.event.eventId) {
        
        if (items[i].search.startNumber && data.search.startNumber) {
          if (items[i].search.startNumber === data.search.startNumber) {
            const item = items[i];
            item.date = data.date;
            item.search = data.search;
            result.push(item);
            duplicate = true;
            continue;
          }
          result.push(items[i]);
        } else if (items[i].search.selfieId && data.search.selfieId) {
          if (items[i].search.selfieId === data.search.selfieId) {
            const item = items[i];
            item.date = data.date;
            item.search = data.search;
            result.push(item);
            duplicate = true;
            continue;
          }
          result.push(items[i]);
        } else {
          result.push(items[i]);
        }

      } else {
        
        result.push(items[i]);
      }
    }

    if (!duplicate) {
      result.push(data);
    }

    return result;
  }

  async saveRecent(itemName: string, data: any[]): Promise<void> {
    const items: any[] = await this.getNewest(data);
    this.storage.setItem(itemName, JSON.stringify(items));
  }

  async getNewest(items: any[]): Promise<any[]> {
    let sorted: any[] = items.sort(this.sort);
    sorted.reverse();

    const newest: any[] = [];
    const events: string[] = [];

    for (let i = 0; i < sorted.length; i++) {
      if (events.length == 0) {
        events.push(sorted[i].event.eventId);
        newest.push(sorted[i]);
        continue;
      }

      if (events.length == 1 && events.indexOf(sorted[i].event.eventId) == -1) {
        events.push(sorted[i].event.eventId);
        newest.push(sorted[i]);
        continue;
      }

      if (events.length == 1 && events.indexOf(sorted[i].event.eventId) == 0) {
        const found: any[] = newest.filter((r: any) => r.event.eventId === sorted[i].event.eventId);
        if (found.length < 3) {
          newest.push(sorted[i]);
        }
        continue;
      }

      if (events.length == 2 && events.indexOf(sorted[i].event.eventId) == -1) {
        break;
      }

      if (events.length == 2 && events.indexOf(sorted[i].event.eventId) >= 0) {
        const found: any[] = newest.filter((r: any) => r.event.eventId === sorted[i].event.eventId);
        if (found.length < 3) {
          newest.push(sorted[i]);
        }
        continue;
      }
    }

    return newest;
  }

  sort(a: any, b: any): number {
    if (a.date < b.date) return -1;
    if (a.date > b.date) return 1;
    return 0;
  }

  async saveFirstRecent(itemName: string, data: { event: any, search: any, date: number }): Promise<void> {
    data.date = Date.now();
    this.storage.setItem(itemName, JSON.stringify([data]));
  }

  getCurrentRecent() {
    let current;
    let eventRecentSearch: any = this.storage.getItem('eventRecentSearch');
    if (eventRecentSearch) {
      eventRecentSearch = JSON.parse(eventRecentSearch);
      if (this.isStartNumber(this.number)) {
        current = eventRecentSearch.find((item: any) => {
          return item.event.eventId == this.event?.eventId
            && item.search.startNumber == this.number.toUpperCase()
            && item.search.token;
        });
      } else {
        const num: string[] = this.number.split("+");
        const selfieId: string = num[0];
        const personId: string = num[1];
        current = eventRecentSearch.find((item: { search: any; }) => {
          return item.search.selfieId == selfieId
            && item.search.personId == personId
            && item.search.token;
        });
      }
    }
    return current;
  }

  getSecondaryFactor(competitorRecent: any): any {
    if (!competitorRecent || !competitorRecent.search) return null;
    if (competitorRecent.search.birthDate) return {
      birthDate: competitorRecent.search.birthDate,
    };
    if (competitorRecent.search.code) return {
      code: competitorRecent.search.code,
    };
    if (competitorRecent.search.surname) return {
      surname: competitorRecent.search.surname,
    };
    return null;
  }

  async getNewSearchToken(payload: any): Promise<any> {
    const tokenResult = await this.searchState.getToken(payload);
    if (tokenResult.status !== 200) return null;
    return this.searchState.searchToken;
  }

  async searchTwoFactorByStartNumber(): Promise<void> {
    const token: any = this.searchState.searchToken ? this.searchState.searchToken : null;
    let competitorRecent = this.getCurrentRecent();

    const searchingPhotos = this.event?.searchingPhotos;
    const secondaryFactor = this.getSecondaryFactor(competitorRecent);

    if (searchingPhotos && secondaryFactor) {
      if ((!searchingPhotos.byNumberWithBirthDate && secondaryFactor.birthDate)
          || (!searchingPhotos.byNumberWithCode && secondaryFactor.code)
          || (!searchingPhotos.byNumberWithSurname && secondaryFactor.surname)) {
        competitorRecent = '';
      }
    }

    if (this.startNumberVerificationToken) {
      await this.searchState.verifyToken(this.startNumberVerificationToken);
      if (!this.searchState.verificationError && this.searchState.isVerificationTokenValid) {
        const result: any = await this.getNewSearchToken({
          eventId: this.event?.eventId,
          payload: {
            startNumber: this.number.toUpperCase(),
            code: this.searchState.codeFromVerificationToken,
          },
        });
        if (result) {
          this.searchToken = this.searchState.searchToken ? this.searchState.searchToken : null;
          const payloadForSearch: any = {
            eventId: this.event?.eventId,
            token: result.value,
            pagination: { offset: 0, count: this.photosPerPage },
          }
          await this.searchState.searchByTag(payloadForSearch);

          if (this.searchState.photos.length > 0) {
            const searchData = {
              event: { ...this.event },
              search: {
                startNumber: this.number.toUpperCase(),
                token: result.value,
                complementable: result.complementable,
                code: this.searchState.codeFromVerificationToken,
              },
              date: Date.now(),
            };
            await this.saveRecentSearch(searchData);
            this.recentSearch = searchData;

            await this.showFoundResults();
          } else {
            await this.showNotFoundResults();
          }
        } else {
          await this.$router.push({
            name: 'event',
            params: {
              id: this.event.externalEventId,
            }
          });
          return;
        }
      } else {
        await this.$router.push({
          name: 'event',
          params: {
            id: this.event.externalEventId,
          }
        });
        return;
      }
    } else if (competitorRecent) {
      this.recentSearch = competitorRecent;
      this.searchToken = {
        token: competitorRecent.search.token,
        complementable: competitorRecent.search.complementable === true,
      };
      const payload: any = {
        eventId: this.event?.eventId,
        token: competitorRecent.search.token,
        pagination: { offset: 0, count: this.photosPerPage },
      }
      await this.searchState.searchByTag(payload);
      if (this.searchState.isTokenExpired) {
        const result: any = await this.getNewSearchToken({
          eventId: this.event?.eventId,
          payload: {
            startNumber: competitorRecent.search.startNumber,
            ...secondaryFactor,
          },
        });
        if (result) {
          payload.token = result.value;
          competitorRecent.search.token = result.value;
          competitorRecent.search.complementable = result.complementable === true;
          competitorRecent.date = Date.now();
          await this.searchState.searchByTag(payload);
          await this.saveRecentSearch(competitorRecent);
          this.recentSearch = competitorRecent;
        } else {
          await this.$router.push({
            name: 'event',
            params: {
              id: this.event.externalEventId,
            }
          });
          return;
        }
      }
      if (this.searchState.photos.length > 0) {
        await this.showFoundResults();
      } else {
        await this.showNotFoundResults();
      }
    } else if (token) {
      this.searchToken = { ...token };
      const payload: any = {
        eventId: this.event?.eventId,
        token: token.value,
        pagination: { offset: 0, count: this.photosPerPage },
      }
      await this.searchState.searchByTag(payload);

      let factor = {};
      if (this.birthDate) factor = { birthDate: this.birthDate };
      if (this.code) factor = { code: this.code };
      if (this.surname) factor = { surname: this.surname };

      const searchData = {
        event: { ...this.event },
        search: {
          startNumber: this.number.toUpperCase(),
          token: token.value,
          complementable: token.complementable,
          ...factor,
        },
        date: Date.now(),
      };
      await this.saveRecentSearch(searchData);
      this.recentSearch = searchData;

      if (this.searchState.photos.length > 0) {
        await this.showFoundResults();
      } else {
        await this.showNotFoundResults();
      }
    } else {
      const photoId = new URLSearchParams(window.location.search).get('id');
      if (photoId) {
        const value = {
          externalEventId: this.event.externalEventId,
          startNumber: this.number.toUpperCase(),
          search: window.location.search,
        };
        sessionStorage.setItem('showPhotoAfter2FS', JSON.stringify(value));
      }
      await this.$router.push({
        name: 'event',
        params: {
          id: this.event.externalEventId,
          startNumber: this.number.toUpperCase(),
        }
      });
    }
  }

  async searchTwoFactorBySelfie(): Promise<void> {
    const num: string[] = this.number.split("+");
    const selfieId: string = num[0];
    const personId: string = num[1];

    if (num.length !== 2) {
      await this.$router.push({
        name: 'event',
        params: {
          id: this.event.externalEventId,
        }
      });
    } else if (num[1] === "undefined") {
      this.byFace = "true";
      await this.showNotFoundResults();
    } else {
      await this.searchState.loadBySelfieId({ selfieId: selfieId });
      if (this.searchState.searchError) {
        await this.$router.push({
          name: 'event',
          params: {
            id: this.event.externalEventId,
          }
        });
      } else {
        this.byFace = "true";
        const person = this.searchState.persons.find((item) => item.personId === personId);
        const token: any = this.searchState.searchToken ? this.searchState.searchToken : null;
        let personRecent = this.getCurrentRecent();

        if (personRecent) {
          this.recentSearch = personRecent;
          this.searchToken = {
            token: personRecent.search.token,
            complementable: personRecent.search.complementable === true,
          };
          const payloadForPhotos: any = {
            eventId: this.event?.eventId,
            token: personRecent.search.token,
            pagination: { offset: 0, count: this.photosPerPage }
          };
          await this.searchState.searchByTag(payloadForPhotos);
          if (this.searchState.isTokenExpired) {
            const result: any = await this.getNewSearchToken({
              eventId: this.event?.eventId,
              payload: {
                personId: personRecent.search.personId,
                birthDate: personRecent.search.birthDate,
              },
            });
            if (result) {
              payloadForPhotos.token = result.value;
              personRecent.search.token = result.value;
              personRecent.search.complementable = result.complementable === true;
              personRecent.date = Date.now();
              await this.searchState.searchByTag(payloadForPhotos);
              await this.saveRecentSearch(personRecent);
              this.recentSearch = personRecent;
            } else {
              await this.$router.push({
                name: 'event',
                params: {
                  id: this.event.externalEventId,
                }
              });
              return;
            }
          }
        } else if (token && person) {
          this.searchToken = { ...token };
          const payload: any = {
            eventId: this.event?.eventId,
            token: token.value,
            pagination: { offset: 0, count: this.photosPerPage },
          }
          await this.searchState.searchByTag(payload);

          const faceUrl = person?.faceUrl || "";
          const searchData = {
            event: { ...this.event },
            search: {
              selfieId,
              personId,
              faceUrl,
              token: token.value,
              complementable: token.complementable,
              birthDate: this.birthDate,
            },
            date: Date.now(),
          };
          await this.saveRecentSearch(searchData);
          this.recentSearch = searchData;
        } else {
          await this.showNotFoundResults();
        }

        if (this.searchState.searchError) {
          await this.showNotFoundResults();
        } else if (this.searchState.photos.length > 0) {
          await this.showFoundResults();
        } else {
          await this.showNotFoundResults();
        }
      }
    }
  }

  async searchTwoFactorByEmail(): Promise<void> {
    const eventId: any = this.$route.query['list-id'];

    await this.eventsState.getEventById(eventId);
    const event: any = { ...this.eventsState.event };
    event["is2FAEnabled"] = event.competitorsListProtected === true;
    this.event = event;

    const startNumbers: any = this.$route.query['start-numbers'];
    let numbers = [];
    if (startNumbers) {
      numbers = startNumbers.split(',');
      if (numbers.length > 1) {
        this.participants = numbers;
        this.$store.state.history = ["home", "event"];
        this.showChoiceParticipant = true;
        return;
      } else if (numbers.length === 1) {
        this.showChoiceParticipant = false;
      } else {
        await this.$router.push({
          name: 'event',
          params: {
            id: this.event.externalEventId,
          }
        });
        return;
      }
    }

    const payloadForToken = {
      eventId,
      payload: {
        startNumber: numbers[0],
        verificationId: this.$route.query['verification-id'],
        verificationCode: this.$route.query['verification-code'],
      },
      lang: this.lang,
    };
    const tokenResult: any = await this.searchState.getToken(payloadForToken);
    if (tokenResult.status !== 200) {
      await this.$router.push({
        name: 'event',
        params: {
          id: this.event.externalEventId,
        }
      });
      return;
    }
    this.searchToken = this.searchState.searchToken ? this.searchState.searchToken : null;

    const payloadForSearch = {
      eventId: eventId,
      token: this.searchToken ? this.searchToken.value : '',
      pagination: { offset: 0, count: this.photosPerPage },
    };
    await this.searchState.searchByTag(payloadForSearch);

    const startNumber: any = numbers[0] || 'email';
    const searchData = {
      event: { ...this.event },
      search: {
        startNumber,
        token: this.searchToken ? this.searchToken.value : '',
        complementable: this.searchToken ? this.searchToken.complementable : false,
      },
      date: Date.now(),
    };
    await this.saveRecentSearch(searchData);

    await this.$router.replace({
      name: "search-from-url",
      params: {
        id: this.event.externalEventId,
        number: startNumber,
      }
    })

    if (this.searchState.photos.length > 0) {
      await this.showFoundResults();
    } else {
      await this.showNotFoundResults();
    }
  }

  async onSelectParticipant(number: string): Promise<void> {
    this.showChoiceParticipant = false;

    const payloadForToken = {
      eventId: this.event.eventId,
      payload: {
        startNumber: number,
        verificationId: this.$route.query['verification-id'],
        verificationCode: this.$route.query['verification-code'],
      },
      lang: this.lang,
    };
    const tokenResult: any = await this.searchState.getToken(payloadForToken);
    if (tokenResult.status !== 200) {
      await this.$router.push({
        name: 'event',
        params: {
          id: this.event.externalEventId,
        }
      });
      return;
    }
    this.searchToken = this.searchState.searchToken ? this.searchState.searchToken : null;

    const payloadForSearch = {
      eventId: this.event.eventId,
      token: this.searchToken ? this.searchToken.value : '',
      pagination: { offset: 0, count: this.photosPerPage },
    };
    await this.searchState.searchByTag(payloadForSearch);

    const startNumber: any = number || 'email';
    const searchData = {
      event: { ...this.event },
      search: {
        startNumber,
        token: this.searchToken ? this.searchToken.value : '',
        complementable: this.searchToken ? this.searchToken.complementable : false,
      },
      date: Date.now(),
    };
    await this.saveRecentSearch(searchData);

    await this.$router.replace({
      name: "search-from-url",
      params: {
        id: this.event.externalEventId,
        number: startNumber,
      }
    })

    if (this.searchState.photos.length > 0) {
      await this.showFoundResults();
    } else {
      await this.showNotFoundResults();
    }
  }

  async searchTwoFactor(): Promise<void> {
    if (this.isStartNumber(this.number)) {
      this.searchType = SearchTypes.startNumber;
      this.searchTwoFactorByStartNumber();
    } else if (this.isEmail) {
      this.searchType = SearchTypes.email;
      this.searchTwoFactorByEmail();
    } else {
      this.searchType = SearchTypes.selfie;
      this.searchTwoFactorBySelfie();
    }
  }

  async getCart(): Promise<void> {
    await this.cartState.loadCartId();

    if (this.cartState.cartId != "") {
      await this.cartState.getCart({ cartId: this.cartState.cartId });

      if (this.cartState.isCartError) {
        await this.cartState.removeCart();
      }
    }
  }

  isSearchDisabled(): boolean {
    const searchingPhotos = this.event.searchingPhotos;
    return !searchingPhotos.byTag && !searchingPhotos.byFace && !searchingPhotos.byEmail
           && !searchingPhotos.byNumberWithBirthDate && !searchingPhotos.byNumberWithCode
           && !searchingPhotos.byNumberWithSurname;
  }

  async mounted(): Promise<void> {
    this.$store.state.buttonHome = false;
    this.$store.state.buttonBack = true;
    this.$store.state.buttonCart = true;
    this.$store.state.showMenu = false;
    this.$store.state.goBack = "";

    await this.settingsState.setAppBarHidden(false);
    await this.settingsState.setModalActive(false);
    await this.settingsState.setLoadingRoute(true);

    await this.getCart();

    this.backToTop();
    
    if (this.paramId && this.number) {
      
      await this.eventsState.getEventByExternalId(this.paramId);

      let event: any = this.eventsState.event ? { ...this.eventsState.event } : null;
      if (event === null) {
        if (this.$route.name === "search-from-url" && this.startNumberVerificationToken) {
          this.$store.state.history = ["home"];
          this.showIsProcessing = true;
          await this.settingsState.setLoadingRoute(false);
          return;
        }
        await this.$router.push("/");
        return;
      }

      this.byFace = "false";
      if (this.$store.state.history.length == 0) {
        this.$store.state.history = ["home"];
      }

      await this.eventsState.getEventById(event.eventId);
      event = { ...this.eventsState.event };
      event["is2FAEnabled"] = this.eventsState.event.competitorsListProtected === true;
      this.event = event;

      if (this.isSearchDisabled()) {
        this.$store.state.history = ["home"];
        this.showIsProcessing = true;
        await this.settingsState.setLoadingRoute(false);
        return;
      }

      if (!this.event.is2FAEnabled) {
        this.searchByTag(this.event.eventId, this.number);
      } else {
        await this.searchTwoFactor();
      }
    } else if (!this.hasArgs) {
      if (this.isEmail) {
        await this.searchTwoFactor();
        return;
      }
      await this.$router.push("/");
      return;
    }
  }
}
